var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3H19L20 6L18.2595 5.12976C18.099 5.04952 17.9081 5.06107 17.7525 5.15036C17.2658 5.42956 16.1329 6 15 6C13.8671 6 12.7342 5.42956 12.2475 5.15036C12.0919 5.06107 11.901 5.04952 11.7405 5.12976L10 6L11 3Z",
    fill: "#C7003B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79278 7.94736C9.37289 4.79822 11.8228 2 14.9998 2V2C18.1768 2 20.6267 4.79822 20.2068 7.94737L19.5285 13.0351C19.2258 15.3049 17.2897 17 14.9998 17V17C12.7099 17 10.7738 15.3049 10.4711 13.0351L9.79278 7.94736Z",
    stroke: "#C7003B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19L4.31785 20.1705C3.52235 20.3694 2.92884 21.0337 2.82047 21.8465L2.45287 24.6035C2.21307 26.402 3.61218 28 5.42655 28H24.5734C26.3878 28 27.7869 26.402 27.5471 24.6035L27.1795 21.8465C27.0712 21.0337 26.4776 20.3694 25.6821 20.1705L21 19",
    stroke: "#C7003B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0c1b0f90a714338a690aae57fcc9f50d.svg";
export { ForwardRef as ReactComponent };